import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';
import { ApiHttpClient } from 'app/http/clients/api';

const baseUrl = `${environment.API_URL}`;


export interface NaicsIndustry {
  title: string;
  code: number;
}
@Injectable({
  providedIn: 'root'
})
export class NaicsService {

  constructor(private http: ApiHttpClient) { }

  getMappedIndustryNames(): Observable<{label: string, value: number}[]> {
    return this.http.get<{label: string, value: number}[]>(`${baseUrl}/mappedIndustries`);
  }

  search(terms: string): Observable<NaicsIndustry[]> {
    return this.http.get<NaicsIndustry[]>('/naics', {
      params: {
        year: '2012',
        terms,
      }
    });
  }

  find(code: string): Observable<NaicsIndustry> {
    return this.http.get<NaicsIndustry>('/naics/find', {
      params: {
        year: '2012',
        code: code,
      }
    });
  }
}
